import { FunctionComponent, useEffect, useRef } from "react";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { EventView } from "./EventView";
import { Loader } from "@ui-kit/Loader/Loader";
import { useParams } from "react-router";
import { useAppDispatch } from "@store/store";
import { setSelectedEntityAction } from "@store/map/mapReducer";
import { useGetEventQuery } from "@store/services/event";
import { Text } from "@ui-kit/Text/Text";

import "./Event.css";

interface EventProps {
  idOrSlug?: string;
}

const Event: FunctionComponent<EventProps> = ({ idOrSlug: eventIdOrSlug }) => {
  const values = useParams();
  const idOrSlug = (values.idOrSlug ?? eventIdOrSlug) as string;
  const containerRef = useRef<HTMLDivElement>(null);
  const windowSize = useWindowSize();
  const dispatch = useAppDispatch();
  const { data: event, isFetching, isError } = useGetEventQuery(idOrSlug);

  useEffect(() => {
    if (event) {
      containerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      dispatch(setSelectedEntityAction({ entity: event, type: "Event" }));
    }

    return () => {
      dispatch(setSelectedEntityAction(undefined));
    };
  }, [dispatch, event]);

  useEffect(() => {
    const div = containerRef.current;
    if (div) {
      const newHeight = windowSize.height - div.getBoundingClientRect().top;
      div.style.height = `${newHeight}px`;
    }
  }, [windowSize, containerRef, event]);

  return (
    <div className="entity-flyout event-component" data-testid="entity-flyout">
      <div className="container" ref={containerRef}>
        {isFetching && (
          <div className="event-loading">
            <Loader size="small" />
          </div>
        )}
        {isError && (
          <div className="entity-error">
            <Text variant="fontBodyMedium">Unable to load item</Text>
          </div>
        )}
        {event && <EventView event={event} />}
      </div>
    </div>
  );
};

export { Event };
